var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 198 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_48)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2506 131.999C41.2506 118.352 52.351 107.259 66.0006 107.259L90.7506 107.249V131.999C90.7506 145.649 79.6478 156.749 66.0006 156.749C52.351 156.749 41.2506 145.649 41.2506 131.999ZM131.999 41.2506C145.649 41.2506 156.749 52.351 156.749 66.0006C156.749 79.6478 145.649 90.7506 131.999 90.7506H107.249V66.0006C107.249 52.3535 118.352 41.2506 131.999 41.2506ZM107.249 0C198 0 198 81.6775 198 90.7508V107.249C198 116.323 198 198 107.249 198H16.5008C0 198 0 198 0 181.502V16.5008C0 0 0 0 16.5008 0H107.249ZM131.999 107.249C154.742 107.249 173.25 88.7436 173.25 66.0008C173.25 43.2556 154.742 24.75 131.999 24.75C109.256 24.75 90.7508 43.2556 90.7508 66.0008V90.7508H66.0008C43.258 90.7508 24.75 109.256 24.75 131.999C24.75 154.742 43.258 173.25 66.0008 173.25C88.7436 173.25 107.249 154.742 107.249 131.999V107.249H131.999Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 198,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.280a546b0193a07f8ee46f2f18a86b6c.svg";
export { ForwardRef as ReactComponent };